import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface FinancialField {
    key: string;
    label: string;
}

interface FinancialRow {
    year: number | null;
    [key: string]: number | null;
}

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.reviewops-shell {
  min-height: 100vh;
  color: #172033;
  background: radial-gradient(circle at 8% -10%, rgba(20, 184, 166, 0.12), transparent 34%), radial-gradient(circle at 92% 0%, rgba(59, 130, 246, 0.09), transparent 30%), #f4f7fa;
}

.ro-card {
  border: 1px solid #e3e9ef;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 35px rgba(23, 32, 51, 0.055);
}

.ro-label {
  display: block;
  margin-bottom: 7px;
  color: #465166;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.ro-input,
.ro-select,
.ro-textarea {
  width: 100%;
  border: 1px solid #dce3ea;
  border-radius: 10px;
  background: #fff;
  color: #172033;
  font-size: 13px;
  outline: none;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.ro-input,
.ro-select {
  height: 42px;
  padding: 0 12px;
}

.ro-textarea {
  min-height: 88px;
  padding: 11px 12px;
  resize: vertical;
}

.ro-input:focus,
.ro-select:focus,
.ro-textarea:focus {
  border-color: #14b8a6;
  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.11);
}

.ro-finance-table {
  width: 100%;
  min-width: 720px;
  border-collapse: separate;
  border-spacing: 0;
}

.ro-finance-table th,
.ro-finance-table td {
  border-bottom: 1px solid #edf1f4;
  padding: 9px 12px;
}

.ro-finance-table th {
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
}

.ro-finance-table th:first-child,
.ro-finance-table td:first-child {
  position: sticky;
  left: 0;
  z-index: 1;
  min-width: 185px;
  background: #fff;
}

.ro-finance-table th:first-child {
  background: #f8fafc;
  z-index: 2;
}

.ro-finance-table td:first-child {
  color: #445065;
  font-size: 12px;
  font-weight: 650;
}

.ro-finance-input {
  width: 100%;
  min-width: 132px;
  height: 36px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 10px;
  color: #1e293b;
  font-size: 12px;
  text-align: right;
  outline: none;
}

.ro-finance-input:focus {
  border-color: #14b8a6;
  box-shadow: 0 0 0 2px rgba(20, 184, 166, 0.1);
}

.ro-score-ring {
  position: relative;
  width: 148px;
  height: 148px;
  border-radius: 50%;
}

.ro-score-ring::after {
  position: absolute;
  inset: 12px;
  border-radius: 50%;
  background: #fff;
  content: "";
}

.ro-score-content {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.ro-chart-grid {
  background-image: linear-gradient(to right, rgba(148, 163, 184, 0.12) 1px, transparent 1px), linear-gradient(to bottom, rgba(148, 163, 184, 0.12) 1px, transparent 1px);
  background-size: 40px 32px;
}

.ro-metric-card {
  overflow: hidden;
  position: relative;
}

.ro-metric-card::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: #14b8a6;
  content: "";
}

.ro-status-excellent,
.ro-status-good {
  color: #087f73;
  background: #ccfbf1;
}

.ro-status-average {
  color: #9a6700;
  background: #fef3c7;
}

.ro-status-weak,
.ro-status-high-risk {
  color: #b42318;
  background: #fee4e2;
}

@media (max-width: 720px) {
  .ro-score-ring {
    width: 128px;
    height: 128px;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public stage: string = 'input';
    public result: any = null;
    public errorMessage: string = '';

    public industries: string[] = [
        'SaaS / Software', 'AI / Data', 'Platform', 'E-commerce',
        'Manufacturing', 'Semiconductor', 'Healthcare / Bio', 'Fintech',
        'Consumer / Retail', 'Logistics', 'Mobility', 'Energy', 'Other'
    ];

    public company: Record<string, string | number | null> = {};
    public financials: FinancialRow[] = [];

    public financialFields: FinancialField[] = [
        { key: 'revenue', label: '매출액' },
        { key: 'cogs', label: '매출원가' },
        { key: 'operating_income', label: '영업이익' },
        { key: 'net_income', label: '당기순이익' },
        { key: 'total_assets', label: '총자산' },
        { key: 'fixed_assets', label: '유형·고정자산 (Optional)' },
        { key: 'total_liabilities', label: '총부채' },
        { key: 'total_equity', label: '자기자본' },
        { key: 'current_assets', label: '유동자산' },
        { key: 'current_liabilities', label: '유동부채' },
        { key: 'cash', label: '현금 및 현금성자산' },
        { key: 'operating_cash_flow', label: '영업활동현금흐름' },
        { key: 'investing_cash_flow', label: '투자활동현금흐름' },
        { key: 'capex', label: 'CAPEX' },
        { key: 'interest_expense', label: '이자비용' }
    ];

    public async ngOnInit() {
        await this.service.init();
        this.loadSample(false);
    }

    public emptyFinancial(year: number): FinancialRow {
        const row: FinancialRow = { year: year };
        this.financialFields.forEach((field) => row[field.key] = null);
        return row;
    }

    public async loadSample(render: boolean = true) {
        this.company = {
            name: '클라우드리서치랩',
            founded_year: 2021,
            description: '기업의 리서치와 실사 데이터를 한곳에서 관리하고 의사결정을 지원하는 B2B SaaS 기업',
            products: '클라우드 기반 투자 리서치 워크스페이스',
            services: '기업용 데이터 분석 소프트웨어 서비스',
            technologies: 'Cloud API와 analytics engine',
            customers: '벤처캐피탈, 액셀러레이터, 기업 전략팀',
            business_model: '사용자 수와 기능 등급에 따른 연간 Subscription Revenue 모델',
            revenue_model: '연간 B2B 구독료',
            market: '한국 및 아시아 B2B 투자 소프트웨어 시장',
            known_industry: ''
        };
        this.financials = [
            {
                year: 2024, revenue: 75, cogs: 25, operating_income: -16, net_income: -19,
                total_assets: 94, fixed_assets: 8, total_liabilities: 37, total_equity: 57,
                current_assets: 70, current_liabilities: 23, cash: 42,
                operating_cash_flow: -12, investing_cash_flow: -6, capex: 4, interest_expense: 1.1
            },
            {
                year: 2025, revenue: 132, cogs: 37, operating_income: 2, net_income: -2,
                total_assets: 133, fixed_assets: 10, total_liabilities: 47, total_equity: 86,
                current_assets: 102, current_liabilities: 28, cash: 55,
                operating_cash_flow: 5, investing_cash_flow: -8, capex: 5, interest_expense: 1.3
            },
            {
                year: 2026, revenue: 196, cogs: 43, operating_income: 24, net_income: 16,
                total_assets: 176, fixed_assets: 12, total_liabilities: 54, total_equity: 122,
                current_assets: 139, current_liabilities: 31, cash: 73,
                operating_cash_flow: 20, investing_cash_flow: -10, capex: 7, interest_expense: 1.5
            }
        ];
        this.stage = 'input';
        this.result = null;
        this.errorMessage = '';
        if (render) await this.service.render();
    }

    public async resetForm() {
        this.company = {
            name: '', founded_year: null, description: '', products: '', services: '',
            technologies: '', customers: '', business_model: '', revenue_model: '',
            market: '', known_industry: ''
        };
        this.financials = [
            this.emptyFinancial(2024),
            this.emptyFinancial(2025),
            this.emptyFinancial(2026)
        ];
        this.stage = 'input';
        this.result = null;
        this.errorMessage = '';
        await this.service.render();
    }

    public payload() {
        const cleanFinancials = this.financials.map((row) => {
            const cleaned: FinancialRow = { year: row.year };
            this.financialFields.forEach((field) => {
                const value = row[field.key];
                cleaned[field.key] = value === '' || value === undefined ? null : value;
            });
            return cleaned;
        });
        return { company: this.company, financials: cleanFinancials };
    }

    public async analyze() {
        this.errorMessage = '';
        if (!String(this.company.name || '').trim()) {
            this.errorMessage = '기업명을 입력해주세요.';
            await this.service.render();
            return;
        }
        if (this.financials.some((row) => !row.year)) {
            this.errorMessage = '각 재무 데이터의 연도를 입력해주세요.';
            await this.service.render();
            return;
        }

        await this.service.status.show('loading');
        try {
            const response = await wiz.call('analyze', {
                payload: JSON.stringify(this.payload())
            });
            if (response.code !== 200) {
                this.errorMessage = (response.data && response.data.message) || '분석에 실패했습니다.';
                return;
            }
            this.result = response.data;
            this.stage = 'result';
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (error) {
            this.errorMessage = '분석 서버에 연결하지 못했습니다.';
        } finally {
            await this.service.status.hide('loading');
            await this.service.render();
        }
    }

    public async editInput() {
        this.stage = 'input';
        this.errorMessage = '';
        window.scrollTo({ top: 0, behavior: 'smooth' });
        await this.service.render();
    }

    public async openReport() {
        this.stage = 'report';
        window.scrollTo({ top: 0, behavior: 'smooth' });
        await this.service.render();
    }

    public async backToDashboard() {
        this.stage = 'result';
        window.scrollTo({ top: 0, behavior: 'smooth' });
        await this.service.render();
    }

    public display(value: number | null | undefined, unit: string = ''): string {
        if (value === null || value === undefined) return '데이터 부족';
        const number = Number(value);
        const formatted = Math.abs(number) >= 1000
            ? number.toLocaleString('ko-KR', { maximumFractionDigits: 1 })
            : number.toLocaleString('ko-KR', { minimumFractionDigits: 0, maximumFractionDigits: 1 });
        return formatted + unit;
    }

    public trackByKey(index: number, item: Record<string, string | number | null>): string | number {
        return item.key || item.year || index;
    }
}

export default PageAccessComponent;